<template>
  <v-container>
    <v-layout>
    <v-flex>
      <div>
        <v-layout>
          <v-flex xs6 sm4 d-flex>
            <v-select
              v-model="numDias"
              :items="items"
              label="Número de días"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-btn @click="getOpenedPatientRouteSheet" large color="primary">Obtener hojas</v-btn>
          <v-flex xs6 sm4 offset-sm2>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>

    <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Procedimientos</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="headersProcedimientos"
              :items="procedimientos"
              class="elevation-1"
              sort-icon="mdi-menu-down"
              hide-actions
              hide-headers      
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.name }}</td>          
              </template>
            </v-data-table>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>

    </v-layout>
       <h3 class="primary--text">Hojas de ruta abiertas</h3>
      <v-data-table
        :headers="headers"
        :items="openedPatientRouteSheet"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nombresCompletos }}</td>
          <td class="text-xs-left">{{ props.item.nombreEmpresa }}</td>          
          <td class="text-xs-left">{{ props.item.date }}</td>
          <td class="text-xs-left">{{ props.item.estadoText }}</td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="verProcedimientos(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>done_all</v-icon>
            </v-btn>
            <span>Ver procedimientos</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="redirectToPatient(props.item)" slot="activator" color="primary">
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
            <span>Ir a paciente</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
    import Patient from "../patient/Patient";
    export default {
        data() {
            return {
              search: '',                        
              headers: [
                  { text: 'Paciente', value: 'nombresCompletos' },
                  { text: 'Empresa', value: 'nombreEmpresa' },
                  { text: 'Fecha', value: 'date' },
                  { text: 'Estado', value: 'estadoText' },
                  { text: 'Tipo', value: 'type' },
                  { text: 'Acciones', value: 'acciones' }
              ],
              headersProcedimientos: [
                { text: 'Procedimiento', value: 'name' },
              ],
              editedIndex: -1,            
              openedPatientRouteSheet: [],
              procedimientos: [],
              dialog: false,
              items: [
                      {text: 'Todos', value: '-1'},
                      {text: '15 últimos días', value: '15'}, 
                      {text: '30 últimos días', value: '30'}, 
                      {text: '60 últimos días', value: '60'}, 
                      {text: '90 últimos días', value: '90'}
                    ],
              numDias: '15'
            };
        },
        methods: {        
            getOpenedPatientRouteSheet() {
                this.$store.dispatch('getOpenedPatientsRouteSheet', this.numDias).then(
                    response => {
                        this.openedPatientRouteSheet = response.data;
                        this.$store.state.progress = false;
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            verProcedimientos(item) {
              this.procedimientos = JSON.parse(item.detail);              
              this.dialog = true;
            },
            redirectToPatient(item) {                                               
                this.$store.state.buscadorPaciente = item.identificacionPaciente;                
                const patient = 
                    {
                        path: "/patient",
                        component: Patient
                    };
                this.$router.push(patient);
            }
        },
        computed: {},
        created() {
            this.getOpenedPatientRouteSheet();        
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/OpenedPatientRouteSheets.vue